import {copyToClipboard} from '../utilities/helpers'

export default () => {
  const contents = document.querySelectorAll('.contents-list'),
        contentsDesktop = document.querySelector('.contents-list.desktop'),
        mainContent = document.querySelector('.section-wysiwyg'),
        contentHeaders = mainContent?.querySelectorAll(':scope > h1, :scope > h2, :scope > h3, :scope >  h4, :scope >  h5, :scope >  h6');

  contents?.forEach(list => {
    contentHeaders?.forEach((header, i) => {
      const listElement = document.createElement('li'),
            link = document.createElement('a'),
            headerId = `header-${i}`;

      link.textContent = header.textContent,
      link.href = `#${headerId}`,
      link.classList.add(headerId);
      header.id = headerId;

      listElement.appendChild(link);
      list.appendChild(listElement);
    });
  });

  const copyLinkBtn = document.querySelector('.copy-link'),
        copyUrl = copyLinkBtn?.getAttribute('data-url');

  copyLinkBtn?.addEventListener('click', function(){
    if(copyUrl){
      const copy = copyToClipboard(copyUrl);
      if(copy){
        this.classList.add('active');
        setTimeout(()=>{
          this.classList.remove('active');
        }, 3000);
      }
    }
  });


  let observerOptions = {
    rootMargin: '0px',
    threshold: 0.5
  }

  var observer = new IntersectionObserver(observerCallback, observerOptions);

  function observerCallback(entries, observer) {
      entries.forEach(entry => {
          if(entry.isIntersecting) {
            const entryId = entry.target.getAttribute('id'),
                  listElement = contentsDesktop.querySelector(`.${entryId}`),
                  contentsElementsDesktop = contentsDesktop.querySelectorAll('li');

            contentsElementsDesktop.forEach(item =>{
              item.classList.remove('active');
            });

            listElement.parentNode.classList.add('active');
          }
      });
  };

  contentHeaders?.forEach(i => {
      if (i) observer.observe(i);
  });
}
